import { endpoints } from 'modules/endpoints'

import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'

type Props = {
  value: string[]
  updateFilterState: (value: Record<string, string[]>) => void
}

export const ResponsibleDCFilter: FC<Props> = ({ value, updateFilterState }) => {
  const { t } = useTranslation()

  return (
    <ABaseTableFilter
      id="responsibleDealCoordinatorFilter"
      onChange={(user_responsibles) => updateFilterState({ user_responsibles })}
      value={value}
      placeholder={t('common:assignee')}
      getLabel={(label) => label.full_name}
      endpoint={endpoints.users('deal-coordinators')}
      searchField="search"
      multiple
    />
  )
}
